const hr = {
  meta: {
    siteName: "Nieder-Eschbacher Pflegedienst GmbH",
    titleSuffix: "Nieder-Eschbacher Pflegedienst",
    description:
      "Nieder-Eschbacher Pflegedienst GmbH, služba kućne njege u Frankfurtu na Majni. Brižna i stručna njega kod kuće: osnovna njega, medicinska njega, pomoć u kućanstvu i dostupnost 24 sata.",
    pages: {
      home: "",
      about: "O nama",
      services: "Usluge",
      news: "Novosti i radna mjesta",
      contact: "Kontakt",
      imprint: "Impressum",
      privacy: "Zaštita podataka",
      notFound: "Stranica nije pronađena",
    },
  },

  common: {
    call: "Nazovi",
    callNow: "Nazovite nas:",
    contactUs: "Kontaktirajte nas",
    bookConsultation: "Dogovorite savjetovanje",
    bookAppointment: "Dogovorite termin",
    requestConsultation: "Zatražite savjetovanje",
    aroundTheClock: "Danonoćno:",
    reachable24h: "Dostupni danonoćno",
    certifiedStaff: "Diplomirano osoblje",
    whatsapp: "WhatsApp",
    whatsappText: "Dobar dan, imam pitanje o vašoj službi njege.",
    whatsappNote: "Molimo ne šaljite zdravstvene podatke putem WhatsAppa. U hitnim slučajevima nazovite nas.",
    symbolImage: "Ilustrativna fotografija",
    language: "Jezik",
    changeLanguage: "Odaberite jezik",
    skipToContent: "Preskoči na sadržaj",
    legalNote: "Ovaj prijevod služi samo u informativne svrhe. Pravno je obvezujuća njemačka verzija.",
  },

  header: {
    topbar24h: "Dostupni 24 sata",
    topbarConsult: "Besplatno i osobno savjetovanje",
    mainNav: "Glavna navigacija",
    mobileNav: "Mobilna navigacija",
    openMenu: "Otvori izbornik",
    closeMenu: "Zatvori izbornik",
  },

  nav: {
    home: "Početna",
    about: "O nama",
    services: "Usluge",
    news: "Novosti",
    contact: "Kontakt",
    jobs: "Radna mjesta",
    imprint: "Impressum",
    privacy: "Zaštita podataka",
  },

  footer: {
    reach: "Kako do nas",
    fax: "Faks:",
    emergency: "Hitni broj 24 sata:",
    navigation: "Navigacija",
    legal: "Pravne informacije",
    area: "Frankfurt na Majni i okolica (težište Nieder-Eschbach)",
    rights: "Sva prava pridržana.",
  },

  floating: {
    whatsappLabel: "Pišite nam na WhatsAppu",
    callLabel: "Nazovite nas:",
    toTop: "Na vrh stranice",
  },

  home: {
    eyebrow: "Služba kućne njege · Frankfurt na Majni",
    h1a: "Brižna i stručna",
    h1b: "njega kod kuće",
    lead:
      "Za bezbrižan život, čak i kada dob ili bolest zahtijevaju njegu. Imamo vremena za vas.",
    heroImgAlt: "Njegovateljica tvrtke Nieder-Eschbacher Pflegedienst drži ruke na ramenima nasmiješenog starijeg gospodina; uz logo i usluge: osnovna njega, medicinska njega, pomoć u kućanstvu, individualna skrb",
    badgeTitle: "Sa srcem i vremenom",
    badgeText: "Njega bez žurbe",
    welcomeQuote:
      "Mi, tim Nieder-Eschbacher Pflegedienst u Frankfurtu na Majni, radujemo se vašem interesu. Iz dana u dan zalažemo se za ljude koji nam poklanjaju povjerenje i pružamo kvalitetnu njegu u privatnosti vašeg doma. Naše ljubazno osoblje ima vremena za vas.",
    features: [
      {
        icon: "Clock",
        title: "Imamo vremena",
        text: "Brižan pristup bez žurbe. Želimo da se kod nas osjećate ugodno.",
        to: "about",
        cta: "O nama",
      },
      {
        icon: "HeartHandshake",
        title: "Naše usluge",
        text: "Osnovna i medicinska njega, prilagođena upravo vama.",
        to: "services",
        cta: "Usluge",
      },
      {
        icon: "Newspaper",
        title: "Novosti i radna mjesta",
        text: "Novosti iz naše službe i slobodna radna mjesta u njezi.",
        to: "news",
        cta: "Novosti",
      },
    ],
    servicesEyebrow: "Naše usluge",
    servicesTitle: "Individualna skrb, sasvim prema vašim potrebama",
    servicesLead:
      "Od osnovne njege do dostupnosti 24 sata: sveobuhvatno vas pratimo u vašem vlastitom domu.",
    valuesEyebrow: "Naše vrijednosti",
    valuesTitle: "Poštovanje, briga i odgovoran odnos",
    valuesLead:
      "Poštovanje, briga i odgovoran odnos naša su najviša načela. Prema svakom čovjeku odnosimo se onako kako bismo željeli da se odnose prema nama.",
    ctaTitle: "Niste sigurni koji stupanj njege imate?",
    ctaLead: "Rado ćemo vas osobno savjetovati, kod nas ili kod vas doma. Besplatno i bez obveze.",
  },

  values: [
    { icon: "Heart", label: "Individualna njega" },
    { icon: "BadgeCheck", label: "Diplomirano osoblje" },
    { icon: "MessageCircle", label: "Osobno savjetovanje" },
    { icon: "ShieldCheck", label: "Odgovoran odnos" },
  ],

  services: [
    {
      id: "grundpflege",
      icon: "HandHeart",
      title: "Osnovna njega",
      short: "Osobna higijena, pomoć pri kretanju i u svakodnevici, mirno i dostojanstveno.",
      description:
        "U osnovnoj njezi s razumijevanjem vam pomažemo pri svim svakodnevnim radnjama vezanim uz higijenu i pokretljivost. Imamo vremena i uvijek poštujemo vaše dostojanstvo i pravo na vlastite odluke.",
      points: [
        "Osobna higijena (pranje, kupanje, tuširanje)",
        "Pomoć pri kretanju i namještanje položaja",
        "Njega kod inkontinencije",
        "Pomoć pri hranjenju",
        "Oblačenje i svlačenje",
      ],
    },
    {
      id: "behandlungspflege",
      icon: "Stethoscope",
      title: "Medicinska njega",
      short: "Medicinska skrb po nalogu liječnika, pouzdano i stručno.",
      description:
        "Medicinska njega obuhvaća sve medicinski potrebne postupke i uvijek se provodi po nalogu liječnika. Naše diplomirano osoblje usko surađuje s vašim liječnicima.",
      points: [
        "Davanje i pripremanje lijekova",
        "Injekcije",
        "Navlačenje i skidanje kompresijskih čarapa",
        "Suvremena njega rana",
        "Kontrola šećera u krvi i krvnog tlaka",
      ],
      note: "Medicinska njega uvijek se provodi po nalogu liječnika.",
    },
    {
      id: "hauswirtschaft",
      icon: "Home",
      title: "Pomoć u kućanstvu",
      short: "Brinemo se o kućanstvu kako biste se kod kuće osjećali potpuno ugodno.",
      description:
        "Uredan dom bitno pridonosi dobrom osjećaju. Pomažemo vam u vođenju kućanstva kako biste se u vlastita četiri zida osjećali opušteno i sigurno.",
      points: [
        "Kupovina i obavljanje poslova",
        "Priprema obroka",
        "Pranje rublja",
        "Čišćenje stana",
      ],
    },
    {
      id: "betreuung",
      icon: "Users",
      title: "Dodatne usluge skrbi",
      short: "Zajedničko vrijeme, razgovor i aktivnosti za više radosti u životu.",
      description:
        "Uz njegu, ljudska pažnja nam je posebno važna. Rasterećujemo članove obitelji koji njeguju i darujemo vam vrijeme za lijepe zajedničke trenutke.",
      points: [
        "Rasterećenje članova obitelji koji njeguju",
        "Vježbe orijentacije",
        "Razgovor i društvo",
        "Rad s biografijom",
      ],
    },
    {
      id: "anleitung",
      icon: "GraduationCap",
      title: "Upute za članove obitelji koji njeguju",
      short: "Pomažemo vašim bližnjima da pomognu vama.",
      description:
        "Članovi obitelji koji njeguju čine velike stvari. Dajemo vam praktične upute i sigurnost u njezi, individualno i razumljivo, u vašem domu.",
      points: [
        "Praktične upute za njegu kod kuće",
        "Savjetovanje o pomagalima",
        "Savjeti za svakodnevicu s njegom",
        "Sigurnost u pružanju njege",
      ],
    },
    {
      id: "erreichbarkeit",
      icon: "Clock",
      title: "Dostupnost 24 sata",
      short: "Na mobitelu smo dostupni danonoćno kako biste se osjećali sigurno.",
      description:
        "U hitnim slučajevima tu smo za vas u svako doba dana i noći. Na našem mobilnom hitnom broju dostupni smo danonoćno.",
      points: [
        "Mobilni hitni broj: 0177 / 7202956",
        "Alternativno: 0157 / 36442746",
        "Brza pomoć u hitnom slučaju",
        "Sigurnost za vas i vaše bližnje",
      ],
    },
  ],

  servicesPage: {
    eyebrow: "Usluge",
    title: "Sveobuhvatna njega, individualno za vas",
    subtitle:
      "Nudimo vam širok spektar usluga njege i pomoći u kućanstvu koje točno prilagođavamo vašoj situaciji.",
    shortLongTitle: "Kratkotrajna i trajna njega",
    shortLongText:
      "Privremeno nakon boravka u bolnici ili trajno: našu njegu fleksibilno prilagođavamo vašoj životnoj situaciji. Tako dobivate upravo onu podršku koja vam je sada potrebna.",
    adviceTitle: "Savjetovanje o stupnjevima njege i osiguranju za njegu",
    adviceText:
      "Sustav njege je složen. Razumljivo vam objašnjavamo na koje usluge imate pravo i korak po korak vam pomažemo pri podnošenju zahtjeva osiguranju za njegu.",
    ctaTitle: "Zatražite besplatno savjetovanje",
    ctaLead: "Rado ćemo vas osobno i bez obveze savjetovati, kod nas ili kod vas doma.",
  },

  about: {
    eyebrow: "O nama",
    title: "Ljudi koji imaju vremena",
    subtitle:
      "Upoznajte naš tim i našu filozofiju. Obilježavaju nas vrijeme, poštovanje, briga i istinska ljudskost.",
    introTitle: "Vaša dobrobit je u središtu",
    intro: [
      "Mi smo tim Nieder-Eschbacher Pflegedienst u Frankfurtu na Majni. Iz dana u dan zalažemo se za ljude koji nam poklanjaju povjerenje. Njega je za nas puno više od posla. Ona je stvar srca.",
      "Naše ljubazno, diplomirano osoblje svjesno odvaja vrijeme za vas. Jer dobra skrb treba mir, pažnju i otvoreno uho, bez žurbe.",
      "Njegujemo vas ondje gdje se najbolje osjećate: u vlastitom domu, u poznatom okruženju. Tako ostaju očuvane vaša samostalnost i privatnost.",
    ],
    teamImgAlt: "Njegovateljica brižno drži ruke starije gospođe u invalidskim kolicima (ilustrativna fotografija)",
    valuesTitle: "Vrijednosti koje nas vode",
    valuesLead: "Poštovanje, briga i odgovoran odnos naša su najviša načela.",
    pillars: [
      { icon: "Clock", title: "Vrijeme", text: "Radimo bez žurbe i poklanjamo vam istinsku pažnju." },
      { icon: "Heart", title: "Briga", text: "Svaki je čovjek jedinstven. Takva je i naša njega." },
      { icon: "Home", title: "Dom", text: "Njega u poznatom okruženju koje daje sigurnost." },
    ],
    ctaTitle: "Upoznajte nas",
    ctaLead: "Radujemo se osobnom razgovoru s vama.",
  },

  newsPage: {
    eyebrow: "Novosti",
    title: "Novosti i radna mjesta",
    subtitle: "Novosti iz naše službe njege i slobodna radna mjesta za sve koji žele postati dio našeg tima.",
    newsTitle: "Novosti",
    newsLead: "Aktualne informacije iz naše službe njege.",
    careerEyebrow: "Karijera",
    careerTitle: "Postanite dio našeg tima",
    careerLead:
      "Volite njegu i želite raditi u srdačnom timu koji ima istinsko vrijeme za ljude? Onda se radujemo vašoj prijavi.",
    applyNow: "Prijavite se",
    applySubject: "Prijava: Pomoćnik/ica u njezi (ž/m/d)",
    tasks: "Vaši zadaci",
    profile: "Vaš profil",
    offer: "Nudimo",
    interested: "Zainteresirani? Pošaljite prijavu na",
    orCall: "ili nas nazovite na",
    questions: "Pitanja? Kontaktirajte nas",
  },

  news: [
    {
      id: "willkommen",
      date: "2026-09-21",
      category: "Novosti",
      title: "Dobro došli na našu novu web stranicu",
      excerpt:
        "Radujemo se što vam našu službu njege i naše usluge od sada možemo predstaviti i online: pregledno, jasno i uvijek dostupno.",
      body: "Naš je cilj vama i vašim bližnjima učiniti lako dostupnima sve važne informacije o njezi kod kuće. Za pitanja nas u svakom trenutku možete dobiti telefonom ili putem kontaktnog obrasca.",
    },
    {
      id: "pflegeberatung",
      date: "2025-10-28",
      category: "Savjetovanje",
      title: "Besplatno savjetovanje o njezi kod nas ili kod vas doma",
      excerpt:
        "Niste sigurni koji vam stupanj njege odgovara? Rado ćemo vas osobno i bez obveze savjetovati o svim pitanjima vezanim uz osiguranje za njegu i stupnjeve njege.",
      body: "Njemački sustav njege je složen. Odvajamo vrijeme, mirno vam objašnjavamo mogućnosti i pomažemo pri podnošenju zahtjeva za usluge. Jednostavno dogovorite termin.",
    },
    {
      id: "team-verstaerkung",
      date: "2025-10-05",
      category: "Tim",
      title: "Rastemo i tražimo pojačanje",
      excerpt:
        "Naš tim stalno raste. Postanite dio srdačnog kolektiva koji njegu živi s vremenom i poštovanjem.",
      body: "Nudimo poštene radne uvjete, odnos pun uvažavanja i istinsko vrijeme za ljude o kojima se brinemo. Pogledajte naša aktualna radna mjesta.",
    },
  ],

  jobs: [
    {
      id: "pflegehelfer",
      title: "Pomoćnik/ica u njezi (ž/m/d)",
      type: "Nepuno ili puno radno vrijeme",
      location: "Frankfurt na Majni, Nieder-Eschbach",
      intro:
        "Za pojačanje našeg tima tražimo pomoćnika/icu u njezi koji/koja će oživjeti naše vrijednosti: vrijeme, poštovanje i brigu. Dobrodošli su i oni koji mijenjaju zanimanje, a imaju srce za ovaj posao.",
      tasks: [
        "Pomoć pri osnovnoj njezi naših korisnika",
        "Pomoć pri kretanju i u svakodnevici",
        "Pratnja i ljudska pažnja",
        "Uska suradnja u timu za njegu",
      ],
      requirements: [
        "Radost u radu s ljudima i empatija",
        "Pouzdanost, odgovornost i timski duh",
        "Prvo iskustvo u njezi je prednost (nije nužno)",
        "Vozačka dozvola B kategorije je prednost",
      ],
      offer: [
        "Poštena plaća, uvijek na vrijeme",
        "Srdačan tim pun uvažavanja",
        "Istinsko vrijeme za njegu, bez žurbe",
        "Uvođenje u posao te stručno usavršavanje",
      ],
    },
  ],

  contact: {
    eyebrow: "Kontakt",
    title: "Tu smo za vas",
    subtitle:
      "Pitanja o njezi, želja za terminom ili savjetovanje: javite nam se bez obveze. Radujemo se vašem javljanju.",
    formTitle: "Pišite nam",
    formLead: "Javit ćemo vam se što je prije moguće.",
    name: "Ime i prezime",
    namePlaceholder: "Vaše ime",
    email: "E-mail",
    emailPlaceholder: "ime@primjer.de",
    phone: "Telefon",
    phonePlaceholder: "Vaš broj telefona",
    message: "Poruka",
    messagePlaceholder: "Kako vam možemo pomoći?",
    consentBefore: "Pročitao/la sam",
    consentLink: "izjavu o zaštiti podataka",
    consentAfter:
      "i pristajem da se moji podaci (uključujući eventualne zdravstvene podatke u mojoj poruci) obrađuju radi obrade mog upita. Pristanak mogu opozvati u svakom trenutku.",
    submit: "Pošalji poruku",
    sending: "Slanje…",
    subject: "Upit putem web stranice",
    errName: "Molimo unesite svoje ime.",
    errEmail: "Molimo unesite valjanu e-mail adresu.",
    errMessage: "Molimo napišite nam kratku poruku.",
    errConsent: "Molimo prihvatite izjavu o zaštiti podataka.",
    toastCheck: "Molimo provjerite svoje unose.",
    toastSuccess: "Hvala! Vaša je poruka uspješno poslana.",
    toastError: "Došlo je do pogreške. Molimo nazovite nas.",
    successTitle: "Hvala!",
    successText: "Vaša je poruka zaprimljena. Uskoro ćemo vam se javiti.",
    sendAnother: "Pošalji novu poruku",
    reachTitle: "Kako do nas",
    address: "Adresa",
    phoneLabel: "Telefon",
    fax: "Faks",
    emergency: "Hitni broj 24 sata",
    alternatively: "alternativno",
    emailLabel: "E-mail",
    hoursTitle: "Radno vrijeme ureda",
    hours: "Ponedjeljak do petak: 08:00 do 17:00",
    careAndEmergency: "Njega i hitni broj:",
    aroundTheClock: "danonoćno",
    mapTitle: "Kako nas pronaći",
    mapIframeTitle: "Lokacija Nieder-Eschbacher Pflegedienst na Google kartama",
    mapLoad: "Učitaj kartu",
    mapNotice:
      "Radi zaštite podataka karta Google Maps učitava se tek nakon vašeg pristanka. Pritom se podaci prenose Googleu.",
    mapButton: "Učitaj kartu i prikaži lokaciju",
    mapAlt: "Ili otvorite u Google kartama",
  },

  reviews: {
    eyebrow: "Recenzije",
    title: "Što kažu bližnji i pacijenti",
    emptyLead: "Vaše iskustvo pomaže drugim obiteljima u Frankfurtu da pronađu odgovarajuću službu njege.",
    countOn: "recenzija na",
    source: "Javne recenzije iz našeg Google poslovnog profila.",
    asOf: "Stanje:",
    all: "Sve recenzije na Googleu",
    write: "Napišite recenziju",
    on: "na",
    starsLabel: "od 5 zvjezdica",
  },

  notFound: {
    title: "Stranica nije pronađena",
    subtitle: "Pogreška 404",
    text: "Tražena stranica ne postoji ili je premještena.",
    home: "Na početnu stranicu",
  },

  imprint: {
    title: "Impressum",
    subtitle: "Podaci prema § 5 njemačkog Zakona o digitalnim uslugama (DDG)",
    company: "Podaci prema § 5 DDG",
    country: "Njemačka",
    representedBy: "Zastupana po",
    managingDirector: "Direktorica",
    contact: "Kontakt",
    phone: "Telefon",
    fax: "Faks",
    email: "E-mail",
    register: "Upis u registar",
    registerCourt: "Registarski sud",
    registerNumber: "Registarski broj",
    taxNumber: "Porezni broj",
    licence: "Dozvola i nadzorno tijelo",
    licenceText:
      "Ovlaštena služba kućne njege na temelju ugovora o pružanju usluga njege prema § 72 Socijalnog zakonika, knjiga XI (SGB XI), sklopljenog sa zemaljskim savezima osiguravatelja za njegu u Hessenu.",
    authorityText:
      "Nadležno nadzorno tijelo prema hessenskom Zakonu o uslugama skrbi i njege (HGBP):",
    dispute: "Rješavanje potrošačkih sporova",
    disputeText:
      "Nismo voljni niti obvezni sudjelovati u postupcima rješavanja sporova pred tijelom za mirenje u potrošačkim sporovima (§ 36 VSBG).",
    responsible: "Odgovorna za sadržaj prema § 18 st. 2 Državnog ugovora o medijima (MStV)",
    credit: "Koncept i tehnička izvedba",
    liabilityContent: "Odgovornost za sadržaj",
    liabilityContentText:
      "Kao pružatelj usluga odgovorni smo za vlastite sadržaje na ovim stranicama prema općim zakonima. Nismo, međutim, obvezni nadzirati prenesene ili pohranjene tuđe informacije niti istraživati okolnosti koje upućuju na protuzakonitu djelatnost (čl. 8 Uredbe (EU) 2022/2065, Akt o digitalnim uslugama). Obveze uklanjanja ili blokiranja korištenja informacija prema općim zakonima ostaju netaknute. Odgovornost u tom pogledu moguća je tek od trenutka saznanja o konkretnoj povredi prava. Čim saznamo za takve povrede, odmah ćemo ukloniti te sadržaje.",
    liabilityLinks: "Odgovornost za poveznice",
    liabilityLinksText:
      "Naša stranica sadrži poveznice na vanjske web stranice trećih osoba na čiji sadržaj nemamo utjecaja. Stoga za te tuđe sadržaje ne možemo preuzeti jamstvo. Za sadržaj povezanih stranica uvijek je odgovoran njihov pružatelj ili operater. Povezane stranice provjerene su u trenutku postavljanja poveznice na moguće povrede prava; protuzakoniti sadržaji tada nisu bili prepoznatljivi. Trajna kontrola sadržaja povezanih stranica bez konkretnih naznaka povrede prava nije razumna. Čim saznamo za povrede prava, odmah ćemo ukloniti takve poveznice.",
    copyright: "Autorsko pravo",
    copyrightText:
      "Sadržaji i djela koje je operater stranice izradio na ovim stranicama podliježu njemačkom autorskom pravu. Umnožavanje, obrada, distribucija i svaka vrsta korištenja izvan granica autorskog prava zahtijevaju pisanu suglasnost dotičnog autora ili tvorca. Preuzimanja i kopije ove stranice dopušteni su samo za privatnu, nekomercijalnu uporabu. Ako sadržaje na ovoj stranici nije izradio operater, poštuju se autorska prava trećih osoba; sadržaji trećih osoba posebno su označeni kao takvi. Ako ipak uočite povredu autorskih prava, molimo da nas o tome obavijestite. Čim saznamo za povrede, odmah ćemo ukloniti takve sadržaje.",
  },

  privacy: {
    title: "Zaštita podataka",
    subtitle: "Informacije o obradi vaših osobnih podataka prema GDPR-u",
    retention: "šest mjeseci",
    lastUpdated: "Stanje: listopad 2026.",
    controller: {
      title: "1. Voditelj obrade",
      lead: "Voditelj obrade podataka na ovoj web stranici u smislu Opće uredbe o zaštiti podataka (GDPR) je:",
      representedBy: "zastupana po direktorici",
      phone: "Telefon",
      fax: "Faks",
      email: "E-mail",
    },
    dpo: {
      title: "Službenik za zaštitu podataka",
      lead: "Našeg službenika za zaštitu podataka možete kontaktirati na:",
    },
    general: {
      title: "2. Općenito o obradi podataka",
      p: [
        "Osobne podatke obrađujemo samo u mjeri u kojoj je to potrebno za funkcionalnu web stranicu i obradu vaših upita. Pravne osnove su čl. 6 st. 1 t. a GDPR-a (privola), čl. 6 st. 1 t. b GDPR-a (ugovor ili predugovorne radnje) i čl. 6 st. 1 t. f GDPR-a (legitimni interes za siguran i stabilan rad ove web stranice).",
        "Ova web stranica **ne koristi kolačiće**, ne pohranjuje informacije na vaš uređaj (§ 25 TDDDG) i ne koristi usluge analitike, praćenja ili oglašavanja. Fontovi i slike isporučuju se s našeg vlastitog poslužitelja; pri otvaranju stranica ne prenose se podaci uslugama fontova ili slika trećih strana. Ne provodi se automatizirano donošenje odluka, uključujući izradu profila (čl. 22 GDPR-a).",
      ],
    },
    hosting: {
      title: "3. Hosting i poslužiteljske datoteke zapisa",
      ownIntro:
        "Ovu web stranicu po našem nalogu vodi {operator} na poslužitelju u Njemačkoj. Pružatelj podatkovnog centra i poslužitelja je {provider}.",
      logs: "Pri svakom pristupu obrađuju se tehnički nužni podaci o vezi: IP adresa, datum i vrijeme pristupa, pozvana stranica, količina prenesenih podataka, vrsta i verzija preglednika, operacijski sustav te prethodno posjećena stranica (referrer). Ti se podaci ne povezuju s drugim izvorima podataka i služe isključivo isporuci web stranice, sigurnosti i analizi pogrešaka. Pravna osnova je čl. 6 st. 1 t. f GDPR-a. Poslužiteljske datoteke zapisa pohranjuju se samo onoliko dugo koliko je potrebno za siguran rad, a zatim se brišu ili anonimiziraju.",
      ownLegal:
        "S voditeljem rada i pružateljem podatkovnog centra sklopljeni su ugovori o obradi podataka prema čl. 28 GDPR-a. U okviru hostinga ne dolazi do prijenosa u treće zemlje.",
    },
    form: {
      title: "4. Kontaktni obrazac",
      p: [
        "Ako nam pošaljete upit putem kontaktnog obrasca, obrađujemo podatke koje ste unijeli (ime, e-mail adresu, po želji broj telefona i vašu poruku) radi obrade upita i eventualnih dodatnih pitanja. Pravna osnova je čl. 6 st. 1 t. b GDPR-a (uspostava odnosa njege) i, ako nam priopćite zdravstvene podatke, vaša izričita privola prema čl. 9 st. 2 t. a GDPR-a koju dajete označavanjem polja u obrascu.",
        "Obvezni podaci su ime, e-mail adresa i poruka; broj telefona je dobrovoljan. Bez obveznih podataka ne možemo obraditi vaš upit; u tom slučaju uvijek nas možete nazvati. Prijenos je šifriran (TLS). Vaš se upit pohranjuje isključivo na poslužitelju u Njemačkoj koji radi po našem nalogu i ne prosljeđuje se trećim osobama. Podatke brišemo najkasnije {retention} nakon završne obrade vašeg upita, ako ne dođe do uspostave odnosa njege i ako tome ne proturječe zakonske obveze čuvanja. Privolu možete u svakom trenutku opozvati s učinkom za budućnost, npr. e-mailom na {email}.",
      ],
    },
    emailPhone: {
      title: "5. Kontakt putem e-maila, telefona ili WhatsAppa",
      p: [
        "Ako nas kontaktirate e-mailom ili telefonom, obrađujemo vaše podatke radi rješavanja vašeg zahtjeva (čl. 6 st. 1 t. b i t. f GDPR-a). Imajte na umu da nešifrirane e-mail poruke tijekom prijenosa mogu pročitati treće osobe; za zdravstvene podatke preporučujemo telefon ili osobni razgovor.",
        "E-mail poruke na adresu {email} stižu nam preko usluge preusmjeravanja: dostavu obavlja {forwarder}, a poštanski sandučić nalazi se kod {mailbox}. Pritom se obrađuju vaša adresa pošiljatelja, predmet i sadržaj poruke te se podaci prenose i u SAD. Pravna osnova je čl. 6 st. 1 t. f GDPR-a. Stoga vas molimo da nam zdravstvene podatke ne šaljete e-mailom, nego da za to koristite telefon ili osobni razgovor.",
        "Na našoj web stranici nalazi se poveznica putem koje nam možete pisati na WhatsAppu. Pružatelj je WhatsApp Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irska. Poveznica je obična uputnica: tek kada je kliknete uspostavlja se veza s WhatsAppom te se vaš broj mobitela i sadržaj poruke prenose WhatsAppu. Pravna osnova je čl. 6 st. 1 t. b GDPR-a. WhatsApp obrađuje podatke i izvan EU; Meta je certificirana prema EU-US Data Privacy Frameworku. Molimo ne šaljite zdravstvene podatke putem WhatsAppa, a u hitnim slučajevima koristite telefon.",
      ],
    },
    applications: {
      title: "6. Prijave za posao",
      p: [
        "Prijave na naša radna mjesta šaljete nam e-mailom. Vaše dokumente za prijavu obrađujemo isključivo radi provođenja postupka zapošljavanja (čl. 6 st. 1 t. b GDPR-a, § 26 BDSG). Nakon završetka postupka dokumenti se brišu najkasnije nakon šest mjeseci, osim ako ste pristali na dulje čuvanje ili dođe do zasnivanja radnog odnosa.",
      ],
    },
    maps: {
      title: "7. Google Maps (rješenje s dva klika)",
      p: [
        "Na stranici s kontaktom nudimo kartu usluge Google Maps. Pružatelj je Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irska. Karta se učitava **tek nakon vašeg izričitog klika** na „Učitaj kartu“; prije toga se Googleu ne prenose nikakvi podaci. Klikom pristajete (čl. 6 st. 1 t. a GDPR-a) da Google obrađuje vašu IP adresu i podatke o korištenju te ih po potrebi prenosi na poslužitelje Google LLC-a u SAD-u; pritom Google može postaviti kolačiće na vaš uređaj. Google je certificiran prema EU-US Data Privacy Frameworku i dodatno koristi standardne ugovorne klauzule. Vaša privola vrijedi samo za trenutačni prikaz stranice. Više informacija: [policies.google.com/privacy](https://policies.google.com/privacy).",
      ],
    },
    rights: {
      title: "8. Vaša prava",
      lead: "U vezi sa svojim osobnim podacima imate prema nama sljedeća prava:",
      items: [
        "Pravo na pristup (čl. 15 GDPR-a)",
        "Pravo na ispravak (čl. 16 GDPR-a)",
        "Pravo na brisanje (čl. 17 GDPR-a)",
        "Pravo na ograničenje obrade (čl. 18 GDPR-a)",
        "Pravo na prenosivost podataka (čl. 20 GDPR-a)",
        "Pravo na prigovor na obradu temeljenu na čl. 6 st. 1 t. f GDPR-a (čl. 21 GDPR-a)",
        "Pravo na opoziv dane privole s učinkom za budućnost (čl. 7 st. 3 GDPR-a)",
      ],
      how: "Za ostvarivanje svojih prava dovoljna je neformalna poruka na {email} ili poštom na gore navedenu adresu.",
    },
    authority: {
      title: "9. Pravo na pritužbu nadzornom tijelu",
      lead: "Imate pravo podnijeti pritužbu nadzornom tijelu za zaštitu podataka (čl. 77 GDPR-a). Za nas je nadležan:",
      name: "Hessenski povjerenik za zaštitu podataka i slobodu informiranja",
      address: "Gustav-Stresemann-Ring 1, 65189 Wiesbaden, Njemačka",
      url: "https://datenschutz.hessen.de",
      urlLabel: "datenschutz.hessen.de",
    },
    security: {
      title: "10. Sigurnost podataka",
      p: [
        "Ova web stranica isporučuje se isključivo putem šifrirane HTTPS veze (TLS). Primjenjujemo tehničke i organizacijske mjere kako bismo vaše podatke zaštitili od gubitka, manipulacije i neovlaštenog pristupa te ih stalno prilagođavamo stanju tehnike.",
      ],
    },
    changes: {
      title: "11. Izmjene ove izjave o zaštiti podataka",
      p: [
        "Ovu izjavu o zaštiti podataka prilagođavamo kada se promijeni pravno stanje ili naša web stranica. Vrijedi verzija objavljena ovdje.",
      ],
    },
  },
};

export default hr;
